export default __webpack_public_path__ + "static/sh-566d7ffc60eb62afcbeed5ca17df02a9.svg";